import { useState } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';

export interface AmplitudeEventProps {
  // biome-ignore lint/complexity/noBannedTypes: legacy type usage
  data?: Object;
  event: string;
  once?: boolean;
}

const useAmplitudeLog = () => {
  const [timesEvent, setTimesEvent] = useState(0);
  const { logEvent } = useAmplitude();

  const amplitudeEvent = ({ data, event, once }: AmplitudeEventProps) => {
    setTimesEvent(timesEvent + 1);

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (once && timesEvent > 0) return;

    logEvent({
      event,
      data: {
        ...getSourceEventParams(),
        ...data,
      },
    });
  };

  return {
    amplitudeEvent,
  };
};

export default useAmplitudeLog;
